import { computed } from 'vue'
import { useStore } from '@/composables/useStore.ts'
import type { User } from '@/types/store/models/user.js'

export function useCurrentUser() {
  const { store } = useStore()

  const currentUser = computed<User>(() => store.getters['users/me'])

  return {
    me: currentUser,
  }
}
